import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

import * as Sentry from "@sentry/vue";
import { lazyLoad } from "./directives/lazyLoad";

const app = createApp(App);

Sentry.init({
    app,
    dsn: "https://d7d8b50447de690ef967568f40bcbbc6@o4506661066637312.ingest.us.sentry.io/4508890173472768",
    integrations: [
        Sentry.browserTracingIntegration({ router }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["dashboard-api.teq.capital"],
    // Prevent sending errors from localhost
    enabled: window.location.hostname !== 'localhost',
});

app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false || 'none'
        }
    }
});

// Register global directives
app.directive('lazy-load', lazyLoad);

app.mount("#app");
